import { render, staticRenderFns } from "./StorageCardExam.vue?vue&type=template&id=07aa8e8c&scoped=true&"
import script from "./StorageCardExam.vue?vue&type=script&lang=js&"
export * from "./StorageCardExam.vue?vue&type=script&lang=js&"
import style0 from "./StorageCardExam.vue?vue&type=style&index=0&id=07aa8e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aa8e8c",
  null
  
)

export default component.exports